export default __webpack_public_path__ + "android-studio.68ad8bcb.png";